import { FC, ReactNode } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AccountView } from './AccountView';
import { AccountData } from './AccountData';

export interface AccountProps {
    placeholder?: ReactNode;
    env: string;
}

export const Account: FC<AccountProps> = ({ placeholder, env }) => {
    return (
        <Routes>
            <Route
                path="*"
                element={
                    <AccountData>
                        <AccountView env={env} placeholder={placeholder} />
                    </AccountData>
                }
            />
        </Routes>
    );
};
